import classNames from "classnames";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { memo } from "react";

import { useCalendarContext } from "../../context/calendar_context";
import css from "./days.module.scss";

interface IProps {
  startDate: string;
  daysCount: number;
}

const DayDividers = memo(({ startDate, daysCount }: IProps) => {
  const { dayWidth } = useCalendarContext();
  const { formatDate, utc } = useDateFormatter();

  return (
    <div className={css.dayDividersRoot}>
      {[...Array(Math.floor(daysCount))].map((_, i) => {
        const date = utc(startDate).add(i, "days");
        const formattedDate = formatDate(date);
        const dayOffset = date.diff(utc(startDate), "days");
        return (
          <div
            key={formattedDate}
            className={classNames(css.day, css.dayDivider)}
            title={formattedDate}
            style={{ width: dayWidth, left: dayWidth * dayOffset }}
          />
        );
      })}
    </div>
  );
});

DayDividers.displayName = "DayDividers";

export default DayDividers;
